import { ruRU } from '@mui/material/locale'
import { createTheme } from '@mui/material/styles'

export const defaultTheme = createTheme({
  palette: {
    primary: {
      main: '#0ed8da',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#0ed8da',
      contrastText: '#ffffff',
    },
  },
  typography: {
    fontFamily: 'Montserrat, sans-serif',
    fontWeightRegular: 500,
    fontSize: 13
  },
}, ruRU);
